// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectLabel } from '@weezevent/nacre';

export default function SelectInput({ label, value, onChange = () => {}, options, ...params }) {
    const { t } = useTranslation();

    return (
        <SelectLabel
            useNew
            label={label}
            value={value}
            options={options}
            placeholder={t('ticket.common.action.select')}
            onChange={selected => {
                onChange(selected);
            }}
            onClear={() => onChange(null)}
            {...params}
        />
    );
}
